import React, { useState, useEffect } from 'react';
import { useSignIn, useClerk } from '@clerk/clerk-react';
import { useAppAuth } from '../context/AuthContext';
import './EventAuthBar.css';

export default function EventAuthBar() {
  const { isLoaded, isSignedIn, user, minecraftUuid, minecraftUsername } = useAppAuth();
  const { signIn } = useSignIn();
  const { signOut } = useClerk();
  const [signingIn, setSigningIn] = useState(false);

  // Auto-link Minecraft if signed in but not linked
  useEffect(() => {
    if (!isLoaded || !isSignedIn || minecraftUsername) return;
    const key = 'xbox_redirect_pending';
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    sessionStorage.setItem('xbox_return_path', window.location.pathname);

    const state = crypto.randomUUID();
    sessionStorage.setItem('xbox_oauth_state', state);
    const params = new URLSearchParams({
      client_id: '42d27845-af7e-42ba-8c15-1ec7bcaca4b6',
      response_type: 'code',
      redirect_uri: `${window.location.origin}/xbox-callback`,
      scope: 'XboxLive.signin XboxLive.offline_access',
      state,
    });
    window.location.href = `https://login.microsoftonline.com/consumers/oauth2/v2.0/authorize?${params}`;
  }, [isLoaded, isSignedIn, minecraftUsername]);

  const handleSignIn = async () => {
    setSigningIn(true);
    try {
      const origin = window.location.origin;
      const returnPath = window.location.pathname;
      sessionStorage.setItem('xbox_return_path', returnPath);
      await signIn.authenticateWithRedirect({
        strategy: 'oauth_microsoft',
        redirectUrl: `${origin}/sso-callback`,
        redirectUrlComplete: returnPath,
      });
    } catch {
      setSigningIn(false);
    }
  };

  if (!isLoaded) return null;

  if (!isSignedIn) {
    return (
      <div className="event-auth-bar">
        <button
          className="event-auth-signin"
          onClick={handleSignIn}
          disabled={signingIn}
        >
          <svg className="event-auth-ms-logo" viewBox="0 0 21 21" width="16" height="16">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          {signingIn ? 'Redirecting...' : 'Sign In'}
        </button>
      </div>
    );
  }

  const displayName = minecraftUsername || user?.firstName || user?.primaryEmailAddress?.emailAddress || 'Player';

  return (
    <div className="event-auth-bar">
      <div className="event-auth-profile">
        {minecraftUuid ? (
          <img
            src={`https://mc-heads.net/avatar/${minecraftUuid}/32`}
            alt={displayName}
            className="event-auth-avatar"
          />
        ) : (
          <div className="event-auth-avatar-placeholder">
            {displayName.charAt(0).toUpperCase()}
          </div>
        )}
        <span className="event-auth-name">{displayName}</span>
        <button
          className="event-auth-signout"
          onClick={() => signOut({ redirectUrl: window.location.pathname })}
          title="Sign out"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
